export default __webpack_public_path__ + "static/media/AnaVeriHazırlamaÖrnekExcelData.b7cfd2b3.xlsx";